import React from 'react'
import { Nav, Hero } from '../../components'
import './Header.css'

const Header = () => {
  return (
    <div className="container-xxl header-container">
      <Nav />
      <Hero />
    </div>
  )
}

export default Header
